<template>
  <div class="posts-wrapper">
    <div class="packages">
      <div class="filters">
        <div class="title">Búsqueda</div>
        <div class="wrap-filter">
          <div class="item">
            <label for="">Fechas</label>
            <v-date-picker
              mode="range"
              v-model="dateFilter"
              locale="es"
              :popover="{ placement: 'top', visibility: 'click' }"
            ></v-date-picker>
          </div>
          <div class="item">
            <vs-select
              ref="ratingSelect"
              autocomplete
              multiple
              label="Calificación"
              class="letters"
              v-model="ratingsSelected"
            >
              <vs-select-item value="unrated" text="Sin calificar" />
              <vs-select-item
                :key="item"
                :value="item"
                :text="`${item} ${item === 1 ? 'estrella' : 'estrellas'}`"
                v-for="item in [1, 2, 3, 4, 5]"
              />
            </vs-select>
          </div>
          <div class="item btnFilter">
            <vs-button
              color="danger"
              type="border"
              icon="block"
              @click="clearFilters()"
              v-if="hasFilters"
            >Limpiar</vs-button>
            <vs-button
              id="btnExportSurveys"
              class="vs-con-loading__container"
              :class="{ 'ml-10': hasFilters }"
              color="success"
              type="border"
              icon="cloud_download"
              @click="downloadSurveys()"
              :disabled="isDownloading"
            >Exportar</vs-button>
          </div>
        </div>
      </div>

      <div
        class="box-white-wrapper vs-con-loading__container"
        :class="{ 'is-loading': isLoading }"
      >
        <vs-table :data="surveys" :key="keyPackages" v-if="surveys.length > 0">
          <template slot="thead">
            <vs-th sort-key="customerName">Cliente</vs-th>
            <vs-th sort-key="customerEmail">Email</vs-th>
            <vs-th sort-key="tracking">Tracking</vs-th>
            <vs-th sort-key="createdAt">Fecha</vs-th>
            <vs-th sort-key="answer">Calificación</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].customerName">
                {{ data[indextr].customerName }}
              </vs-td>
              <vs-td :data="data[indextr].customerEmail">
                {{ data[indextr].customerEmail || "Sin Definir" }}
              </vs-td>
              <vs-td :data="data[indextr].tracking">
                <router-link
                  :to="`/package/${data[indextr].pkg01Id}`"
                  v-if="data[indextr].tracking && data[indextr].pkg01Id"
                >{{ data[indextr].tracking }}</router-link>
                <span v-else>{{ data[indextr].tracking || "Sin Definir" }}</span>
              </vs-td>
              <vs-td :data="data[indextr].createdAt">
                {{ data[indextr].createdAt | moment("DD/MM/YYYY") }}
              </vs-td>
              <vs-td :data="data[indextr].answer">
                <router-link
                  :to="`/package/${data[indextr].pkg01Id}`"
                  class="no-rating-reason"
                  v-if="!data[indextr].answer && data[indextr].reason && data[indextr].pkg01Id"
                >{{ reasonText(data[indextr].reason) }}</router-link>
                <router-link
                  :to="`/package/${data[indextr].pkg01Id}`"
                  class="rate-service"
                  v-else-if="!data[indextr].answer && data[indextr].pkg01Id"
                >Calificar</router-link>
                <div class="option-stars survey-list" v-else>
                  <template v-for="star in [1, 2, 3, 4, 5]">
                    <feather
                      :key="star"
                      :class="{ active: star <= Number(data[indextr].answer) }"
                      type="star"
                    ></feather>
                  </template>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="pager" v-if="pagination.totalPages > 1">
          <vs-button
            color="primary"
            type="flat"
            icon="chevron_left"
            :disabled="pagination.page <= 1 || isLoading"
            @click="goToPage(pagination.page - 1)"
          ></vs-button>
          <span>Página {{ pagination.page }} de {{ pagination.totalPages }} ({{ pagination.total }} registros)</span>
          <vs-button
            color="primary"
            type="flat"
            icon="chevron_right"
            :disabled="pagination.page >= pagination.totalPages || isLoading"
            @click="goToPage(pagination.page + 1)"
          ></vs-button>
        </div>

        <div class="no-results" v-if="surveys.length === 0 && !isLoading">
          No hay calificaciones para los filtros seleccionados.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { helper } from "@/helpers/utils";
import { Role } from "@/helpers/Role.js";
import PackageDataService from "@/services/PackageDataService";
import { SurveyReasons } from "@/helpers/SurveyReasons";

const FILTERS_STORAGE_KEY = "boxSurveyFilters";

export default {
  name: "Surveys",
  mixins: [helper],
  data() {
    return {
      surveys: [],
      dateFilter: null,
      ratingsSelected: [],
      keyPackages: 0,
      isLoading: false,
      isDownloading: false,
      pagination: { page: 1, pageSize: 50, total: 0, totalPages: 0 },
      // No reactivos: solo coordinan el debounce y descartan respuestas viejas.
      filterTimer: null,
      lastRequestId: 0,
      restoringFilters: false,
    };
  },
  created() {
    this.Roles = Role;
    this.restoreFilters();
  },
  computed: {
    ...mapState(["userInfoData"]),
    hasFilters() {
      return this.dateFilter != null || this.ratingsSelected.length > 0;
    },
  },
  watch: {
    // Rango incompleto todavia no es un filtro: v-calendar emite el modelo
    // mientras se arrastra la seleccion.
    dateFilter(value) {
      if (value != null && (!value.start || !value.end)) return;
      this.scheduleSearch();
    },
    // "Sin calificar" y las estrellas conviven en el mismo dropdown: el
    // backend acepta unrated y ratings a la vez y los combina con OR.
    ratingsSelected() {
      if (this.restoringFilters) return;
      this.scheduleSearch();
    },
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted() {
    this.retrieveSurveys();
    // restoreFilters() asigna los filtros en created(), lo que encola los
    // watchers para el proximo tick. La consulta de arriba ya los incluye, asi
    // que se ignora esa primera pasada y no se dispara una segunda peticion.
    this.$nextTick(() => {
      this.restoringFilters = false;
    });

    // Bug de vuesax: el listener global que cierra el vs-select al hacer
    // click afuera busca la clase ".vs-select--option" (singular), que no
    // existe en ningun elemento real (el contenedor usa ".vs-select--options",
    // plural), asi que nunca matchea y termina cerrando el dropdown con
    // cualquier click, incluyendo el de las opciones. El listado de opciones
    // ademas se monta aparte en <body>, fuera de este componente, asi que se
    // frena la propagacion ahi mismo para que ese listener global no se
    // entere de los clicks internos.
    const optionsEl = this.$refs.ratingSelect && this.$refs.ratingSelect.$refs.vsSelectOptions;
    if (optionsEl) {
      optionsEl.addEventListener("click", (event) => event.stopPropagation());
    }
  },
  beforeDestroy() {
    clearTimeout(this.filterTimer);
  },
  methods: {
    reasonText(code) {
      let _found = SurveyReasons.find((item) => item.value === code);
      return _found ? _found.text : code;
    },
    persistFilters() {
      try {
        localStorage.setItem(
          FILTERS_STORAGE_KEY,
          JSON.stringify({
            dateFilter: this.dateFilter
              ? {
                  start: this.$moment(this.dateFilter.start).format("YYYY-MM-DD"),
                  end: this.$moment(this.dateFilter.end).format("YYYY-MM-DD"),
                }
              : null,
            ratings: this.ratingsSelected,
          })
        );
      } catch (e) {
        // Modo privado o storage lleno: los filtros no se guardan, la pantalla sigue.
        console.log(e);
      }
    },
    restoreFilters() {
      let saved = null;

      try {
        saved = JSON.parse(localStorage.getItem(FILTERS_STORAGE_KEY));
      } catch (e) {
        // JSON corrupto de una version anterior del formato.
        console.log(e);
        localStorage.removeItem(FILTERS_STORAGE_KEY);
      }

      if (!saved) return;

      if (saved.dateFilter && saved.dateFilter.start && saved.dateFilter.end) {
        let start = this.$moment(saved.dateFilter.start, "YYYY-MM-DD");
        let end = this.$moment(saved.dateFilter.end, "YYYY-MM-DD");

        if (start.isValid() && end.isValid()) {
          // v-calendar espera objetos Date, no strings.
          this.dateFilter = { start: start.toDate(), end: end.toDate() };
          this.restoringFilters = true;
        }
      }

      if (Array.isArray(saved.ratings)) {
        // Se descarta cualquier valor fuera de 1..5 (y distinto de "unrated")
        // por si cambia el formato.
        let ratings = saved.ratings
          .map((item) => (item === "unrated" ? item : Number(item)))
          .filter((item) => item === "unrated" || (item >= 1 && item <= 5));

        if (ratings.length > 0) {
          this.ratingsSelected = ratings;
          this.restoringFilters = true;
        }
      }
    },
    // Arma el body de /list y /export. Las llaves sin filtro se omiten,
    // no se mandan vacias ni en null. page/pageSize los ignora /export.
    buildFilters() {
      let filterObj = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      };

      if (this.dateFilter != "" && this.dateFilter != null) {
        filterObj.dateFilter = {
          start: this.$moment(this.dateFilter.start).format("YYYY-MM-DD"),
          end: this.$moment(this.dateFilter.end).format("YYYY-MM-DD"),
        };
      }

      if (this.ratingsSelected.includes("unrated")) {
        filterObj.unrated = true;
      }

      const numericRatings = this.ratingsSelected.filter((item) => item !== "unrated");
      if (numericRatings.length > 0) {
        filterObj.ratings = numericRatings;
      }

      return filterObj;
    },
    // Agrupa cambios seguidos en una sola consulta: elegir tres estrellas
    // en el multiselect no debe disparar tres peticiones.
    scheduleSearch() {
      if (this.restoringFilters) return;
      this.pagination.page = 1;
      this.persistFilters();
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(this.retrieveSurveys, 400);
    },
    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages || page === this.pagination.page) return;
      this.pagination.page = page;
      this.retrieveSurveys();
    },
    clearFilters() {
      this.dateFilter = null;
      this.ratingsSelected = [];
      // Los watchers disparan la consulta; el debounce junta ambos cambios.
    },
    retrieveSurveys() {
      this.isLoading = true;
      // Sin el helper: loadingProgress() usa el color como fondo del overlay y
      // tapa la tabla con una placa opaca. Aca el azul va en el spinner y el
      // fondo queda en el blanco translucido por defecto de vuesax.
      this.$vs.loading({
        container: ".box-white-wrapper",
        background: "rgba(255, 255, 255, 0.6)",
        color: "#1a426d",
        scale: 0.6,
      });

      const requestId = ++this.lastRequestId;

      PackageDataService.getSurveys(this.buildFilters())
        .then((response) => {
          // Una respuesta atrasada no debe pisar a la del filtro vigente.
          if (requestId !== this.lastRequestId) return;
          // vs-table ordena con a[sortKey] y no resuelve rutas anidadas, asi
          // que el tracking se sube al nivel del registro. package puede venir
          // en null si el paquete fue borrado.
          this.surveys = response.data.records.map((item) => ({
            ...item,
            tracking: item.package ? item.package.tracking : null,
          }));
          if (response.data.pagination) {
            this.pagination = response.data.pagination;
          }
          this.isLoading = false;
          this.keyPackages++;
          this.$Progress.finish();
          this.$vs.loading.close(".box-white-wrapper .con-vs-loading");
        })
        .catch((e) => {
          console.log(e);
          if (requestId !== this.lastRequestId) return;
          this.isLoading = false;
          this.$Progress.finish();
          this.$vs.loading.close(".box-white-wrapper .con-vs-loading");
          this.$vs.notify({
            title: "Error!",
            text: "Error obteniendo las calificaciones!",
            color: "danger",
            icon: "error_outline",
          });
        });
    },
    downloadSurveys() {
      this.isDownloading = true;
      this.loadingProgress("#btnExportSurveys");

      PackageDataService.downloadSurveys(this.buildFilters())
        .then((response) => {
          let blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Calificaciones.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);

          this.isDownloading = false;
          this.$vs.loading.close("#btnExportSurveys .con-vs-loading");
          this.$vs.notify({
            title: "Información!",
            text: "La descarga de las calificaciones ha iniciado!",
            color: "success",
            icon: "check",
          });
        })
        .catch((e) => {
          console.log(e);
          this.isDownloading = false;
          this.$vs.loading.close("#btnExportSurveys .con-vs-loading");

          // El 404 no es una falla: significa que no hay datos para esos filtros.
          if (e.response && e.response.status === 404) {
            this.$vs.notify({
              title: "Información!",
              text: "No hay calificaciones para los filtros seleccionados.",
              color: "warning",
              icon: "info_outline",
            });
          } else {
            this.$vs.notify({
              title: "Error!",
              text: "No se pudo generar el reporte.",
              color: "danger",
              icon: "error_outline",
            });
          }
        });
    },
  },
};
</script>
<style scoped>
/* Con la tabla vacia el contenedor colapsa y el spinner queda sin lugar. */
.box-white-wrapper.is-loading {
  min-height: 180px;
}

.no-results {
  padding: 40px 0;
  text-align: center;
  color: #8a8a8a;
}

.rate-service {
  display: block;
  text-align: right;
  color: #28c76f;
  font-family: "Poppins-SemiBold";
  font-size: 12px;
  cursor: pointer;
}

.no-rating-reason {
  display: block;
  text-align: right;
  color: #8a8a8a;
  font-size: 12px;
  cursor: pointer;
}

.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 0 5px;

  span {
    font-size: 13px;
    color: #8a8a8a;
  }
}
</style>
